/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppNumberInput from '../../../shared/components/app-number-input/AppNumberInput';
import { addMarkup, updateMarkup } from '../../../api/profileApi';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import { AIRLINE_NAMES_FOR_CARRIER_CODE } from '../../../shared/constants/FlightCarrierNames';

const valueTypeRef = [
  { label: 'Fixed', value: 'FIXED' },
  { label: 'Percentage', value: 'PERCENTAGE' },
];
const flightCarrierOptionsRef = [
  { label: 'All', value: 'All' },
  { label: 'Spicejet Web(SG)', value: 'SG' },
  { label: 'Jet Airways(9W)', value: '9W' },
  { label: 'Air India(AI)', value: 'AI' },
  { label: 'Indigo Web(6E)', value: '6E' },
  { label: 'Indigo Coupon(6E1)', value: '6E1' },
  { label: 'Indigo Special(6E2)', value: '6E2' },
  { label: 'Indigo Tour Base(6E3)', value: '6E2' },
  { label: 'Indigo Family(6EF)', value: '6EF' },
  { label: 'Indigo IGN (6E4)', value: '6E4' },
  { label: 'Indigo Corporate Scraper(6E5)', value: '6E5' },
  { label: 'Indigo SME(6E7)', value: '6E7' },
  { label: 'Indigo Corporate API(6E8)', value: '6E8' },
  { label: 'Indigo Flexi(6E9)', value: '6E9' },
  { label: 'Indigo SME Corporate(6EC)', value: '6EC' },
  { label: 'Spicejet Coupon[SG1]', value: 'SG1' },
  { label: 'Spicejet Corporate Scraper[SG2]', value: 'SG2' },
  { label: 'Spicejet Tour Base[SG3]', value: 'SG3' },
  { label: 'Spicejet Family[SGF]', value: 'SGF' },
  { label: 'Spicejet Hand Baggage[SGH]', value: 'SGH' },
  { label: 'Spice Jet Retail[SG8]', value: 'SG8' },
  { label: 'Spicejet Corporate API[SG9]', value: 'SG9' },
  { label: 'AirCosta(LB)', value: 'LB' },
  { label: 'Spice Spl Fares(SG5)', value: 'SG5' },
  { label: 'Spice Spl Fares(SG7)', value: 'SG7' },
  { label: 'Air Pegasus(OP)', value: 'OP' },
  { label: 'Indigo Spl Fares(6E6)', value: '6E6' },
  { label: 'Jet Airways Corporate[9W1]', value: '9W1' },
  { label: 'Air India Special[AI1]', value: 'AI1' },
  { label: 'Air India Corporate [AI2]', value: 'AI2' },
  { label: 'Jet Airways Corporate [9W2]', value: '9W2' },
  { label: 'SpiceJet SME Retail[SG6]', value: 'SG6' },
  { label: 'Goair Series[G8S]', value: 'G8S' },
  { label: 'Indigo Series[6ES]', value: '6ES' },
  { label: 'SpiceJet Series[SGS]', value: 'SGS' },
  { label: 'AirIndia Series[AIS]', value: 'AIS' },
];

const busOperatorsRef = [
  { label: 'All', value: 'All' },
  { label: 'RedBus', value: 'redbus' },
  { label: 'Ticketvala', value: 'ticketvala' },
];

const dthOperatorsRef = [
  { label: 'All', value: 'All' },
  { label: 'AIRTEL DTH', value: 'AIRTELDTH' },
  { label: 'BIG TV', value: 'BIGTV' },
  { label: 'DISH TV', value: 'DISHTV' },
  { label: 'SUN DIRECT DTH', value: 'SUNDIRECTDTH' },
  { label: 'TATA SKY TV', value: 'TATASKY' },
  { label: 'VIDEOCON', value: 'VIDEOCON' },
];

const trainOperatorsRef = [{ label: 'IRCTC', value: 'IRCTC' }];

const defaultOptionsRef = [{ label: 'All', value: 'All' }];

function AddOrUpdateMarkup({ onAlert, onClose, selectedMarkUp }) {
  const IntlCarrierOptions = Object.keys(AIRLINE_NAMES_FOR_CARRIER_CODE).map(
    (x) => {
      return {
        label: `${AIRLINE_NAMES_FOR_CARRIER_CODE[x]}(${x})`,
        value: x,
      };
    },
  );
  const { appConfig } = useAppContext();
  const categoryOptionsRef = [];
  if (appConfig.hasFlight) {
    categoryOptionsRef.push(
      ...[
        { label: 'Flights Domestic', value: 'FlightsDomestic' },
        { label: 'Flights International', value: 'FlightsInternational' },
      ],
    );
  }
  if (appConfig.hasHotel) {
    categoryOptionsRef.push(
      ...[
        { label: 'Hotels', value: 'HotelsDomestic' },
        { label: 'Hotel International', value: 'HotelInternational' },
      ],
    );
  }
  if (appConfig.hasBus) {
    categoryOptionsRef.push({ label: 'Buses', value: 'Buses' });
  }
  if (appConfig.hasTrain) {
    categoryOptionsRef.push({ label: 'Trains', value: 'Trains' });
  }
  const [markUp, setMarkUp] = useState(undefined);
  const [selectedCategoryOption, setSelectedCategoryOption] = useState(
    categoryOptionsRef[0]?.value || '',
  );
  const [selectedOptions, setSelectedOptions] = useState(
    flightCarrierOptionsRef,
  );
  const [selectedValueType, setSelectedValueType] = useState('FIXED');
  const [selectedCarrier, setSelectedCarrier] = useState('All');
  const [markupFlat, setMarkupFlat] = useState('');
  const [baseFarePercent, setBaseFarePercent] = useState('');
  const [onBaseFare, setOnBaseFare] = useState('yq');
  const [onBaseFareValue, setBaseFareValue] = useState('');
  const [yqValue, setYqValue] = useState('');
  const [taxValue, setTaxVlaue] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useState(() => {
    if (selectedMarkUp) {
      setMarkUp(selectedMarkUp);
      setSelectedCategoryOption(selectedMarkUp.servicetype);
      setSelectedCarrier(selectedMarkUp.carrier);
      setMarkupFlat(selectedMarkUp.markup_flat);
      setBaseFarePercent(selectedMarkUp.markup_bf);
      setYqValue(selectedMarkUp.markup_yq);
      setTaxVlaue(selectedMarkUp.markup_tax);
      if (selectedMarkUp.markup_yq > 0) {
        setBaseFareValue(selectedMarkUp.markup_yq);
      }
      if (selectedMarkUp.markup_tax > 0) {
        setOnBaseFare('tax');
        setBaseFareValue(selectedMarkUp.markup_tax);
      }
    }
  }, [selectedMarkUp]);

  useEffect(() => {
    if (selectedCategoryOption === 'FlightsInternational') {
      setSelectedOptions(IntlCarrierOptions);
    }
    if (
      selectedCategoryOption === 'FlightsDomestic' ||
      selectedCategoryOption === 'MobileRecharge'
    ) {
      setSelectedOptions(flightCarrierOptionsRef);
    }
    if (selectedCategoryOption === 'DTHRecharge') {
      setSelectedOptions(dthOperatorsRef);
    }
    if (selectedCategoryOption === 'Buses') {
      setSelectedOptions(busOperatorsRef);
    }
    if (selectedCategoryOption === 'Trains') {
      setSelectedOptions(trainOperatorsRef);
      setSelectedCarrier('IRCTC');
    }
    if (
      selectedCategoryOption === 'HotelsDomestic' ||
      selectedCategoryOption === 'PackagesDomestic' ||
      selectedCategoryOption === 'Cabs' ||
      selectedCategoryOption === 'HotelInternational' ||
      selectedCategoryOption === 'Transfers' ||
      selectedCategoryOption === 'sightseeing'
    ) {
      setSelectedOptions(defaultOptionsRef);
    }
  }, [selectedCategoryOption]);

  const handleYqOrTax = (e) => {
    setBaseFareValue(e.target.value);
  };

  const handleCategoryChange = (e) => {
    const d = e.value;
    setSelectedCategoryOption(d);
  };

  const handleAddMarkUp = async () => {
    setIsLoading(true);
    if (selectedMarkUp) {
      let domInt = 'domestic';
      let flatMarkUp = 0;
      let flatBaseFare = 0;
      let yq = yqValue;
      let tax = taxValue;
      if (selectedValueType === 'FIXED') {
        flatMarkUp = markupFlat;
        flatBaseFare = 0;
        yq = 0;
        tax = 0;
      }
      if (selectedValueType === 'PERCENTAGE') {
        flatMarkUp = 0;
        flatBaseFare = baseFarePercent;
        if (onBaseFare === 'yq') {
          yq = onBaseFareValue;
          tax = 0;
        }
        if (onBaseFare === 'tax') {
          tax = onBaseFareValue;
          yq = 0;
        }
      }
      if (
        selectedCategoryOption === 'FlightsInternational' ||
        selectedCategoryOption === 'HotelInternational'
      ) {
        domInt = 'international';
      }
      if (selectedCategoryOption === 'Buses') {
        domInt = 'all';
      }
      const req = {
        markupid: selectedMarkUp.markupid,
        servicetype: selectedCategoryOption,
        carrier: selectedCarrier,
        domint: domInt,
        markup_flat: flatMarkUp,
        markup_bf: flatBaseFare,
        markup_tax: tax,
        markup_yq: yq,
      };
      const response = await updateMarkup(req);
      if (response && response.Root.Status === 'OK') {
        onAlert({
          variant: 'success',
          title: 'Add Mark up',
          description: 'Mark up added successfully',
        });
        onClose(true);
      } else {
        onAlert({
          variant: 'error',
          title: 'Add Mark up',
          description: response.Root.Message,
        });
        onClose(false);
      }
    } else {
      let domInt = 'domestic';
      let flatMarkUp = 0;
      let flatBaseFare = 0;
      let yq = 0;
      let tax = 0;
      if (selectedValueType === 'FIXED') {
        flatMarkUp = markupFlat;
      }
      if (selectedValueType === 'PERCENTAGE') {
        flatBaseFare = baseFarePercent;
        if (onBaseFare === 'yq') {
          yq = onBaseFareValue;
        }
        if (onBaseFare === 'tax') {
          tax = onBaseFareValue;
        }
      }
      if (
        selectedCategoryOption === 'FlightsInternational' ||
        selectedCategoryOption === 'HotelInternational'
      ) {
        domInt = 'international';
      }
      if (selectedCategoryOption === 'Buses') {
        domInt = 'all';
      }
      const request = {
        servicetype: selectedCategoryOption,
        domint: domInt,
        markup_flat: flatMarkUp,
        markup_bf: flatBaseFare,
        markup_tax: tax,
        markup_yq: yq,
        carrier: selectedCarrier,
      };
      const response = await addMarkup(request);
      if (response && response.Root.Status === 'OK') {
        onAlert({
          variant: 'success',
          title: 'Add Mark up',
          description: 'Mark up added successfully',
        });
        onClose(true);
      } else {
        onAlert({
          variant: 'error',
          title: 'Add Mark up',
          description: response.Root.Message,
        });
        onClose(false);
      }
    }

    setIsLoading(false);
  };

  const handleOnClick = () => {
    if (selectedValueType === 'FIXED') {
      if (markupFlat !== '') {
        handleAddMarkUp();
      } else {
        onAlert({
          variant: 'error',
          title: 'Add Mark up',
          description: 'Please add Markup flat value',
        });
      }
    }
    if (selectedValueType === 'PERCENTAGE') {
      if (baseFarePercent !== '' && onBaseFareValue !== '') {
        handleAddMarkUp();
      } else {
        onAlert({
          variant: 'error',
          title: 'Add Mark up',
          description: 'Please add base fare percentage',
        });
      }
    }
  };

  const handleClose = () => {
    onClose(false);
  };

  return (
    <div>
      <AppLoading isLoading={isLoading} />
      <div className="mb-3">
        <AppSelect
          selectedValue={selectedCategoryOption}
          onSelect={handleCategoryChange}
          options={categoryOptionsRef}
          label="Select Category"
          name="servicetype"
          placeholder="Select Category"
          isClearable={false}
        />
      </div>
      <div className="mb-3">
        {selectedOptions !== undefined && (
          <AppSelect
            selectedValue={selectedCarrier}
            onSelect={(d) => setSelectedCarrier(d.value)}
            label="Select Carrier"
            name="selectedCarrier"
            placeholder="Select Carrier"
            options={selectedOptions}
            isClearable={false}
          />
        )}
      </div>
      <div className="mb-3">
        <AppSelect
          selectedValue={selectedValueType}
          onSelect={(d) => setSelectedValueType(d.value)}
          options={valueTypeRef}
          label="Select Airline Type"
          name="selectedValueType"
          placeholder="Select AirlineType"
          isClearable={false}
        />
      </div>
      {selectedValueType === 'FIXED' && (
        <div className="mb-3">
          <AppNumberInput
            value={markupFlat}
            required
            onChange={(val) => setMarkupFlat(val)}
            label="Markup Flat"
            name="markupFlat"
          />
        </div>
      )}
      {selectedValueType === 'PERCENTAGE' && (
        <>
          <div className="mb-3">
            <AppNumberInput
              value={baseFarePercent}
              required
              onChange={(val) => setBaseFarePercent(val)}
              label="% Base Fare"
              name="baseFarePercent"
            />
          </div>
          <div className="mb-3">
            <label className="me-5">
              <input
                type="radio"
                value="yq"
                checked={onBaseFare === 'yq'}
                name="onBaseFare"
                className="me-3"
                onChange={(e) => setOnBaseFare(e.target.value)}
              />
              <span>% YQ</span>
            </label>
            <label>
              <input
                type="radio"
                value="tax"
                checked={onBaseFare === 'tax'}
                name="onBaseFare"
                className="me-3"
                onChange={(e) => setOnBaseFare(e.target.value)}
              />
              <span>% Tax</span>
            </label>
          </div>
          <div className="mb-3">
            <AppTextInput
              value={onBaseFareValue}
              required
              onChange={handleYqOrTax}
              label="% Base Fare"
              name="onBaseFareValue"
            />
          </div>
        </>
      )}
      <div className="mb-3 d-flex justify-content-end">
        <AppButton
          className="me-3"
          variant="outlined"
          btnText="close"
          onClick={handleClose}
        />
        <AppButton
          btnText={selectedMarkUp ? 'Edit MArkup' : 'Add Markup'}
          onClick={handleOnClick}
        />
      </div>
    </div>
  );
}

AddOrUpdateMarkup.defaultProps = {
  selectedMarkUp: undefined,
};

AddOrUpdateMarkup.propTypes = {
  selectedMarkUp: PropTypes.object,
  onAlert: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddOrUpdateMarkup;
